export const GRID_DEFAULT_COLUMNS_NUMBER_DESKTOP = 3;
export const GRID_DEFAULT_COLUMNS_NUMBER_MOBILE = 1;
